/**
 * Temporary rollout gate — only these routes have been migrated to the
 * AI-native redesign so far. Everything else is shown locked across the
 * sidebar and command palette until it ships (see Feature 0: Permissions API
 * for the eventual per-tenant version of this gate).
 */
export const ENABLED_NAV_PATHS = new Set([
  "/", "/assistant", "/workspace", "/agent-builder", "/experiments", "/mmm", "/bid-optimizer",
  // Command Center (demo): two menus — with ML and without ML (partner decks)
  "/command-center/ml", "/command-center/deck",
]);
